<template>
  <DecisionTreeViewerView preview-mode v-if="decisionTree.started" />
  <SlotPicker v-else @select="onSlotSelect" />
</template>

<script setup>
import DecisionTreeViewerView from "./DecisionTreeViewerView.vue";

import SlotPicker from "../components/SlotPicker.vue";
import { useDecisionTreeStore } from "../store/decision-tree";
const { decisionTree, setAppointmentSlot, start: startDecisionTree } = useDecisionTreeStore();

async function onSlotSelect(id) {
  await setAppointmentSlot(id);
  startDecisionTree();
}
</script>
